/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import {assign} from 'xstate';
import axios from 'axios';
import {Utils} from '@sonatype/nexus-ui-plugin';

export default Utils.buildListMachine({
  id: 'ReplicationListMachine',
  sortField: 'sourceRepo',
  config: (config) => ({
    ...config,
    states: {
      ...config.states,
      loaded: {
        ...config.states.loaded,
        on: {
          ...config.states.loaded.on,
          SORT_BY_NAME: {
            target: 'loaded',
            actions: ['setSortByName']
          },
          SORT_BY_SOURCE_REPO: {
            target: 'loaded',
            actions: ['setSortBySourceRepo']
          },
          SORT_BY_TARGET_INSTANCE: {
            target: 'loaded',
            actions: ['setSortByTargetInstance']
          },
          SORT_BY_DESTINATION_REPO: {
            target: 'loaded',
            actions: ['setSortByDestinationRepo']
          }
        }
      }
    }
  }),
  options: (options) => ({
    ...options,
    actions: {
      ...options.actions,
      setSortByName: assign({
        sortField: 'name',
        sortDirection: Utils.nextSortDirection('name')
      }),
      setSortBySourceRepo: assign({
        sortField: 'sourceRepositoryName',
        sortDirection: Utils.nextSortDirection('sourceRepositoryName')
      }),
      setSortByTargetInstance: assign({
        sortField: 'destinationInstanceUrl',
        sortDirection: Utils.nextSortDirection('destinationInstanceUrl')
      }),
      setSortByDestinationRepo: assign({
        sortField: 'destinationRepositoryName',
        sortDirection: Utils.nextSortDirection('destinationRepositoryName')
      }),
      sortData: assign({
        data: function ({sortField, sortDirection, data}) {
          return (data.slice().sort((a, b) => {
            const dir = sortDirection === Utils.ASC ? 1 : -1;
            if (a[sortField] === b[sortField]) {
              return 0;
            }
            if (typeof(a[sortField]) == 'object') {
              return JSON.stringify(a[sortField]).toLowerCase() > JSON.stringify(b[sortField]).toLowerCase() ? dir : -dir;
            }
            else {
              return a[sortField].toLowerCase() > b[sortField].toLowerCase() ? dir : -dir;
            }
          }));
        }
      })
    },
    services: {
      ...options.services,
      fetchData: () => axios.get('/service/rest/beta/replication/connection')
    }
  })
});
